import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { radius } from "src/design/tokens";
import { usePermissions } from "src/grading/hooks/usePermissions";
import { selectCurrentScopes } from "src/store/reducers/auth/authSlice";
import { NavItem, OWN_SCHOOL, navItems, sectionFor } from "./navItems";

export const TopNav = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { hasPermissions } = usePermissions();
  const ownSchoolId = useSelector(selectCurrentScopes)?.schoolIds?.[0];

  const visible = navItems
    .filter(
      (item: NavItem) =>
        (!item.permission ||
          item.permission.some((p) => hasPermissions(p.action, p.subject))) &&
        !item.hiddenWith?.some((p) => hasPermissions(p.action, p.subject)) &&
        (!item.path.includes(OWN_SCHOOL) || Boolean(ownSchoolId)),
    )
    .map((item) => ({
      ...item,
      path: item.path.replace(OWN_SCHOOL, ownSchoolId ?? ""),
    }));
  const active = sectionFor(pathname, {
    schoolNav: visible.some((item) => item.key === "school"),
  });

  return (
    <Box
      component="nav"
      aria-label={t("nav.main")}
      sx={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
    >
      {visible.map((item) => {
        const isActive = item.key === active;
        return (
          <Box
            key={item.key}
            component={RouterLink}
            to={item.path}
            aria-current={isActive ? "page" : undefined}
            sx={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              minHeight: 40,
              padding: "11px 15px",
              borderRadius: `${radius.pill}px`,
              fontSize: 14,
              textDecoration: "none",
              fontWeight: isActive ? 800 : 600,
              bgcolor: (theme) =>
                isActive ? theme.palette.strong : "transparent",
              color: (theme) =>
                isActive
                  ? theme.palette.onStrong
                  : theme.palette.text.secondary,
              "&:hover": { opacity: 0.85 },
              "&::after": {
                content: '""',
                position: "absolute",
                left: 0,
                right: 0,
                top: "50%",
                height: 48,
                transform: "translateY(-50%)",
              },
            }}
          >
            {t(item.label)}
          </Box>
        );
      })}
    </Box>
  );
};

export default TopNav;
